import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ButtonComponent } from './shared/button/button.component';
import { PasswordGenarationPageComponent } from './pages/password-genaration-page/password-genaration-page.component';

@NgModule({
  declarations: [
    AppComponent,
    ButtonComponent,
    PasswordGenarationPageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule // Templates forms
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
